function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "path6183",
  fill: "#006",
  d: "M0 0h640v480H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "path6350",
  fill: "#012169",
  d: "M0 0h320v240H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path6352",
  fill: "#fff",
  d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "path6354",
  fill: "#c8102e",
  d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "path6356",
  fill: "#fff",
  d: "M120.5 0v240h80V0zM0 80v80h320V80z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path6358",
  fill: "#c8102e",
  d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "border",
  stroke: "#fff",
  strokeLinejoin: "round",
  strokeWidth: 9.6,
  transform: "translate(-306.8 -21.2) scale(.87136)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#shield",
  id: "use1093",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#motto1",
  id: "use1095",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#motto2",
  id: "use1097",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rope",
  id: "use1099",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#turtle",
  id: "use1101",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pineapple1",
  id: "use1103",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pineapple2",
  id: "use1105",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "motto1",
  fill: "#fcea83"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1108",
  d: "M754.4 449.6c2.9 7.6 23.5 17.7 47.5 4.8 16.3-9.2 26.8-22 36.9-45 2.8-5.8 4.3-13-2.4-17.3-5.3-3.9-14-8.2-17.8-12-1.9-2-3.8-3.4-5.2-4.8 1 1 1.9 1.9 2.8 3.3 9.6 11.5-.4 28.3-11 38.4-7.7 7.2-21.5 24.9-41.7 8.1-4.3-3.8-14.4 12-9 24.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1110",
  d: "M1045.8 449.6c-3.4 7.6-24 17.7-47.5 4.8-16.2-9.2-26.8-22-37.3-45-2.4-5.8-3.9-13 2.8-17.3 5.3-3.9 14-8.2 17.8-12 1.9-2 3.3-3.4 5.2-4.8-1 1-1.9 1.9-2.8 3.3-9.6 11.5.4 28.3 10.5 38.4 7.7 7.2 22 24.9 42.2 8.1 4.3-3.8 13.9 12 9 24.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1112",
  d: "M900.1 490.8c38.3 0 97.3-17.3 129-77.7 5.2-10 0-15.3-6.3-18.6a73 73 0 0 1-19.2-14c7.7 7.7 6.2 13 1 21.6-24.5 40.8-58 61.4-104.5 61.4s-80-20.6-104.5-61.4c-5.2-8.6-6.7-13.9.5-21.5a66 66 0 0 1-19.2 13.9c-6.2 3.3-11.5 8.6-6.2 18.6 31.6 60.4 91 77.7 129.4 77.7z"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "motto2",
  fill: "#c8102e"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1115",
  d: "M811.4 409.8c-1-4.8-7.1-2.9-9 2.9a68.4 68.4 0 0 1-6.8-10.6c-5.7-8.6-6.7-14.4 1.5-22.5 3.8-3.8 11.5-8.2 16.7-3.4 11 9.1 5.3 24-2.4 33.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1117",
  d: "M988.3 409.8c1-4.8 7.7-2.9 9.6 2.9 2.4-3.4 4.8-6.7 6.7-10.6 5.7-8.6 6.7-14.4-2-22.5-3.3-3.8-11-8.2-16.7-3.4-10.6 9.1-5.3 24 2.4 33.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1119",
  d: "M754.4 449.6c-4.8-7.2-8.6-26-9.6-30.7-1.4-4.3-1.9-8.2 3.4-10 5.3-2 10 4.7 12.4 10.5 2.4 5.7 6.3 14.3 10.6 24.9-10.6-6.2-19.2-2-16.8 5.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1121",
  d: "M1045.8 449.6c4.3-7.2 8.1-26 9.6-30.7 1-4.3 1.9-8.2-3.4-10-5.3-2-10 4.7-12.4 10.5-2.4 5.7-6.3 14.3-10.6 24.9 10.6-6.2 18.7-2 16.8 5.3z"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "g1176",
  fill: "#00493d",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1124",
  d: "m782.2 406.4-3.8 2c-1 .4-1 1.4-1 1.9h-.5L775 406h.5c0 .4.5 1 1.4.4l8.2-4.3c1-.5 1-1 .5-1.4l.4-.5 2.4 4.8h-.4c-.5-.5-1-1-2-.5l-3.3 2 1.4 2.8 3.9-1.4c1-.5.4-1.5.4-2h.5l2 4.4c-.5-.5-1-1-2-.5l-8.1 4.3c-1 .5-1 1-.5 1.4l-.5.5-2.4-4.3.5-.5c.5.5 1 1 2 .5l3.8-2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1126",
  d: "M790.4 412.7c1-.5 1-1 .4-2h.5l4.8 7.2-3.3 2.4v-.4c1.9-1.5 1.9-3.4 1.4-3.9s-1-1-1-1.4c-.4 0-.4-.5-1.4.5l-3.4 2.4c.5.4 1 1.9 3.4.4h.5l-5.3 3.9v-.5c2.4-2 1.4-3.4 1-3.8l-3.4 2.4c-1 .4-1 1-1 1.4.5 0 .5.5 1 1 .5 1 2 1.9 4.3 1l.5.4-3.8 1.4-4.8-7.6h.5c.4.4 1 1 1.9.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1128",
  d: "m798 430.9-3.3 2.8c-.5.5-.5 1.5 0 2h-.5l-3.4-3.4.5-.5c.5.5 1 1 2 0l6.2-6.2c1-.5 1-1 .4-2l3.4 4c-.5-.6-1.4-.6-2 0l-2.8 2.8 2.4 2.4 2.9-2.4c1-1 .5-1.4 0-2l.5-.4 3.3 3.8h-.5c-.4 0-1-.4-1.9.5l-6.2 5.8c-1 1-1 1.4-.5 1.9v.5l-3.3-3.9c.4 0 1.4.5 1.9 0l3.3-3.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1130",
  d: "m805.2 441 1.5 1.4 1.9-4.3s-1.5.4-3.9 1.9l.5 1-.5.4-1-1c-.4.5-.9.5-1.4 1-1.4 1-1 1.5-.4 2v.4l-2.4-2.4h.4l2-.5 9.5-5.2.5.4s-.5.5-4.8 10.1c0 1-.4 1.4 0 2.4l-3.8-3.3.5-.5c.5 1 1.4 1 1.9 0 0-.5.5-1.5.5-2l-1.5-1.4.5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1132",
  d: "m809 450.5.5-.5c.5.5 1 .5 2 0l6.2-8.1-.5-.5c-1-.5-2.4-.5-3.8 1v-.5l1.9-2.4 7.2 5.3-2.4 2.8h-.5c1.4-1.4 1-3.3 0-3.8v-.5l-6.2 8.2c-1 .5-.5 1.4 0 1.9h-.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1134",
  d: "m821.5 452.4-2.4 3.4c-.5 1 0 1.4.5 2l-.5.4-3.8-2.9v-.5c1 .5 1.4.5 1.9-.4l5.3-7.2c.4-1 0-1.5-.5-2l.5-.4 3.8 2.8v.5c-1-.5-1.4-.5-2 .5L822 452l2.9 1.9 2.4-3.4c.4-1 0-1.4-.5-1.9l.5-.5 3.8 2.9v.5c-.5-.5-1.4-.5-2 .5l-4.7 7.6c-1 .5-.5 1 0 1.5v.4l-4.3-2.8h.5c.4 0 1 0 1.4-.5l2.4-3.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1136",
  d: "m831.1 465.9.5-.5c.5.5 1.4.5 1.9-.5l3.8-8.1c.5-1 0-1.5-.5-2l8.2 3.9-2 3.8-.4-.5c1.4-1.9 0-3.8-.5-4.3-.5 0-1-.5-1.4-.5-.5 0-.5 0-1 1-.5.5-1.9 3.3-1.9 3.3.5.5 1.4 1.5 3.4-1h.4l-2.8 5.8-.5-.4c1.4-3-.5-3.4-1-3.4l-1.9 3.8c-.5 1 0 1.5.5 1.5v.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1138",
  d: "M845 472.6c-1.4-1-1.4-3.9 0-6.7 1-3 2.9-5.3 4.8-4.4 1.4.5 1 3.4 0 6.3-1.5 3.3-3.4 5.2-4.8 4.8h-.5c3.4 1.4 5.8-.5 7.2-3.9 1.4-2.8 1-6.2-2-7.6-2.8-1.5-5.7.4-7.1 3.8-1.4 3.4-1 6.7 2 7.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1140",
  d: "m859.8 473.5 2-5.7c.4-1 0-1.5-.5-2l2.4.5v.5c-.5 0-1 0-1.5 1l-1.9 5.7c-1 2.4-2.4 4.3-5.2 3.4-2-.5-3.4-2.9-2.4-5.3l2.4-6.2c.4-1 0-1.5-.5-2v-.4l4.3 1.9v.5c-.5-.5-1.4-.5-1.4.5L855 472c-.5 1.9-.5 3.8 1 4.3 1.4.5 2.8-.5 3.7-2.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1142",
  d: "M864.2 467.3c0-.5 0-.5-.5-.5l3.3.5 3 9.1 1.4-5.8c.4-1 0-1.4-.5-1.9l2.8.5-.4.5c-.5 0-1 0-1.5 1l-2.4 10.5h-.4l-3.9-11.5-2.4 7.7c0 1.4.5 1.4 1 1.9v.5l-2.9-1v-.5c.5.5 1.4 0 1.4-1l2.4-8.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1144",
  d: "M880.5 476.9c-1 4.3-3 5.3-3.9 5.3h-1s-.4-.5 0-1l1.5-9.6c.5-.5.5-1 1-.5h1c.9 0 1.8 2 1.4 5.8l1.4.5c1-4.8-1-6.8-3.4-7.2-1.9-.5-4.8-1-4.8-1v.5c.5.5 1.5.5 1 2l-1.4 8.5c-.5 1-1 1.5-1.5 1.5h-.4l4.7 1c2.4.4 4.8 0 5.8-5.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1146",
  d: "M884.8 473c0-1-1-1.4-1.5-1.4v-.5l8.7 1-.5 3.8c0-2.4-1.5-3.3-2.4-3.3-.5-.5-1-.5-1.5-.5-.4 0-.4 0-.4 1.4l-.5 3.9c.5 0 1.9.4 2.9-2.4l-.5 6.2h-.5c0-2.9-1.4-2.9-2-2.9l-.4 4.3c0 1 0 1 .5 1l1 .5c1.4 0 2.8-.5 3.8-3.4h.5l-1 3.8-9.1-1c1 0 1.4-.4 2-1.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1148",
  d: "M900.6 478.8c0 4.3-1.5 5.7-2.9 5.7-.5-.4-.5-.4-1-.4l-.4-.5.5-10c0-.6 0-.6.4-.6h1c1 0 2.4 1.5 2.4 5.8h1.9c0-4.8-2.4-6.2-4.8-6.2-2-.5-4.8-.5-4.8-.5v.5c.5 0 1.5.4 1.5 1.4l-.5 9.1c0 1-.5 1.4-1 1.4v.5h4.3c2.4 0 4.8-1 5.3-6.2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1150",
  d: "M914.5 482.6c0 1 .5 1 1.4 1v.5l-5.3.4c.5-.4 1.5-1 1.5-1.9l-1-9c-.5-1-1-1-1.9-1v-.5l5.3-.5c-.5.5-1.5 1-1 2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1152",
  d: "M919.3 483.6v-.5c.5 0 1-.5 1-1.4l-2-10h-.5c-1 .4-1.9 1.3-1.4 3.3h-.5l-.5-3.4 8.7-1.4.4 3.3h-.4c0-1.9-1.5-2.4-3-2.4h-.4l2 10c0 1 .4 1.5 1.4 1.5v.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1154",
  d: "m939.9 474-2-5.7c0-1-.9-1-1.4-1v-.5l2.4-1v.5c-.5.5-.5.5-.5 1.5l2 6.2c.4 2 .4 4.8-2.4 5.8-2 .4-4.3-.5-4.8-3.4l-2-6.2c-.4-1-.9-1-1.4-1l-.5-.5 4.8-1.4v.5c-.4.5-1 1-.4 1.9l1.4 6.2c.5 2 2 2.9 3.3 2.9 1.5-.5 2-2.4 1.5-4.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1156",
  d: "M945.2 470.6c2.3-1 1.9-2.3 1.4-3.8-.5-1.4-1.4-2.4-2.4-1.9-.5 0-1 .5-.5 1l1.5 4.7.4.5 1 3.9c.5 1 1.4 1 2 .4v.5l-4.4 2-.5-.5c1-.5 1-1 1-2l-3.4-8.1c-.5-1.4-1-1-1.9-1v-.4l4.8-2c2-.4 3.8 0 4.8 2 .5 2.4-.5 3.8-2.4 4.8-.5 0-1 .4-1 .4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1158",
  d: "M957.1 472c-1.4.6-3.3-1.4-4.8-4.7-1.4-2.9-1.4-5.8 0-6.2 1.5-.5 3.4 1.4 4.8 4.3 1.5 2.9 1.5 5.7 0 6.7 3-1 3.9-4.3 2.4-7.7-1.4-2.9-4.3-4.8-7.2-3.8a5.6 5.6 0 0 0-2.4 7.7c1.5 3.3 4.4 5.2 7.2 3.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1160",
  d: "M957.6 458.7h-.9l2.8-2 8.7 4.8-3-5.2c-.4-1-1.4-1-1.8-1v-.5l2.4-1c-.5.6-1 1 0 2l4.8 9.6-.5.5-10.6-5.8 3.9 7.2c.4 1 1.4 1 1.9.5v.5l-2.4 1.4v-.5c.5-.5.5-1 0-1.9l-3.8-7.7-1.5-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1162",
  d: "M979.2 460.1v-.5c0-.5.5-1 0-1.9l-5.8-8.1h-.5c-1 .4-1.4 2.4 0 3.8l-.4.5-2-3.4 7.2-4.8 2 3c-1.5-1.5-3-1.5-3.9-1l-.5.4 5.8 8.2c.5 1 1.4 1 2 .5v.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1164",
  d: "m984.5 448.6 2.8 3.4c.5.4 1.5.4 2 0v.4l-3.9 3.4v-.5c.5-.5.5-1 0-1.9l-5.7-7.2c-.5-1-1-.5-2-.5l3.9-3.3v.5c0 .4-.5 1 0 1.9l2.4 2.8 2.8-1.9-2.3-3.3c-.5-1-1.5-.5-2-.5l3.9-3.4v.5c-.5.5-.5 1 0 2l5.7 7.1c.5.5 1 .5 1.5 0l.4.5-3.8 3.4-.5-.5c.5-.5 1-1 .5-2l-2.9-3.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1166",
  d: "M988.8 438.5c-.5-.4-1.5-.4-2 0v-.4l6.3-5.8 2.9 2.9h-.5c-1.5-2-3.4-1-4.3-.5 0 .5-.5.5-1 1 0 0 0 .4.5 1.4l2.9 2.9c.4-.5 1.9-1.5 0-3.9h.4l3.9 4.4v.4c-2.4-2.4-3.4-1-3.9-.4l3 2.8c.4 1 .9 1 .9 1l1.4-1.4c.5-.5 1-2 0-4.8h.5l1.9 3.3-6.2 6.2-.5-.4c.5-.5 1-1 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1168",
  d: "M1000.3 425.1c-.5.5-.5 1.5.4 2 1 .9 2 .9 3.9 0 1-.5 2.8-1 4.3.4 2.4 2.4 1.4 4.3 1 5.3-.5.5-1.5 1-2 1.4-.5 0-.5 0-.5.5v.5l-3.3-2.9h.5c1.9 1 3.8 1.4 4.8 0 1-1 0-2-.5-2.4-1-1-2-1-3.4 0-1.4.5-3.3.5-4.8-.5-1.9-1.9-1.9-3.3-1-4.8l2-1.4c.5 0 .5 0 0-1l3.4 2.4h-.5c-2.4-1-3.9-.4-4.3.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1170",
  d: "M1004.6 421.3c-1-.5-1.5 0-2 .5h-.4l5.3-7.7 3.3 2.4-.5.5a3.3 3.3 0 0 0-4.3 0c0 .5-.5 1-.5 1.4-.4 0-.4.5.5 1 .5.5 3.4 2.4 3.4 2.4.5-.5 1.4-1.5-.5-3.4v-.5l4.8 3.9c-2.9-1.5-3.4 0-3.8.4l3.3 2.4c1 .5 1.4.5 1.4.5 0-.5.5-1 1-1.4.5-1 1-2.4-1-4.3l.5-.5 2.4 2.9-4.8 7.2h-.5c.5-1 .5-1.5-.4-2.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1172",
  d: "m1017.5 412.7-1.4 2.4c-2-2-2.9-3.4-2.9-3.4l4.3 1h1c.5 0 1.4.4 1.9.4 1.4.5 1 1 .5 2h.5l2.4-4.4c-1 1-1.5.5-2.4.5-10.1-1.9-11-2.4-11-2.4v.5l7.6 8.6c.5.5.5 1.5.5 2h.5l1.4-2.4-.5-.5c-.5 1-1 1.4-1.9 0l-1-1 1.5-3.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1174",
  d: "M1014.6 402.1c-.4.5-.4 1.5 1 2 1.4.4 2 0 3.4-1s2.8-2 4.7-1c3 1.5 2.4 3.9 2 4.8l-1.5 2v.9l-3.8-2c2.4.5 4.3 0 4.8-1.4.5-1-.5-1.9-1-2.4-1-.4-1.9 0-3.3 1-1.5 1.4-3 2-4.8 1-2-1-2.9-2.4-2-3.9 0-1 1-1.4 1.5-1.9 0-.5 0-.5-.5-1v-.4l3.9 1.9h-.5c-2.4-.5-3.9.5-3.9 1.4z"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "rope",
  fill: "#073163"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1179",
  fill: "#fff",
  d: "M863.2 232.5c-6.2 1.4-10.5 1.9-16.3-3.4-3.8-3.8-2.9-10.5 1-13 4.3-2.8 8.1-4.7 13.4-3.3 5.3 1.5 19.2 14.4 15.8 14.9-3.4 0-8.6 3.3-13.9 4.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1181",
  fill: "#fff",
  d: "M878 209.5c2-1.5 4.4-2.4 10.6-3 5.8-.4 10-.4 11.5 4 2 5.2 3.4 11.4 7.2 14.3-2.4 1.4-14.4 2.9-18.7.5-5.7-2.9-7.2-14-10.5-15.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1183",
  fill: "#fff",
  d: "M919.3 210c1.9-1.5 4.3-1.5 10.5-1s8.6 1 10 5.3c1.5 4.8 0 11 3 15.3-3 1-12.5 1-15.9-2.4-5.2-3.8-4.8-14.9-7.6-17.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1185",
  d: "M948 212.8c-4.3-1-7.2-1.4-9 0 2.3 2.9.4 14.4 5.2 18.2 3.3 2.4 12 3 13.9-2.4 2.4-4.8 2.4-12-10-15.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1187",
  d: "M898.7 208c1.4-1.4 4.3-1.9 10-1.9 6.3 0 10 1 12 4.8 2 4.8 1.4 11 4.8 14.9-1.4 1.9-14.4 1.9-18.2-1-5.3-3.4-5.8-14.4-8.6-16.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1189",
  d: "M858 212.3c0-2.4 3.3-2.8 12-3.3 8.5-1 9-.5 11.9 5.7 1.4 3.4 3.3 9.1 7.2 11-10.6 2.5-14 3.9-19.7.5a29.2 29.2 0 0 1-10-10.5c-.5-1.4-.5-2.9-1.5-3.4z"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "g1268",
  fill: "#f9d050",
  strokeWidth: 0.6
}, /*#__PURE__*/React.createElement("g", {
  id: "pineapple1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1192",
  d: "M881 163.5c-10.1-7.7-22.1-14.9-33.1-16.3a280 280 0 0 1 32.6 25.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1194",
  d: "M886.7 156.3c-12-8.2-25.9-17.3-39.3-18.2a124 124 0 0 1 33 27.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1196",
  d: "M902 142.9a93 93 0 0 1 23.5-32.2c-4.8 10.1-10 30.7-12.5 38.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1198",
  d: "M912.6 140.5A48.4 48.4 0 0 1 937 115a101.2 101.2 0 0 0-18.2 35"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1200",
  d: "M916.9 150a84.5 84.5 0 0 1 37.8-31.6c-12 12-29.7 34-34 42.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1202",
  d: "M923.6 160.6c8.6-4.8 25.9-12.5 38.3-10-7.6 2.8-30.6 13.3-40.7 23"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1204",
  d: "M921.7 157.2c8.1-8.6 23-21.5 38.8-26.8-11.5 11-36 36-39.3 39.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1206",
  d: "M898.7 152c-5.8-17.8-14.4-34.5-27.3-39.8a130.9 130.9 0 0 1 21 48.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1208",
  d: "M887.6 151.5c-9.5-11.5-22.5-23-37.3-25.4a90.1 90.1 0 0 1 33 38.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1210",
  d: "M893 151c-12-21.6-21.2-25.4-26.4-29.7 4.3 8.1 14.8 29.7 21 38.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1212",
  fill: "none",
  d: "M869 149.6a57.7 57.7 0 0 1 17.2 16.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1214",
  d: "M869 159.6c2.8 2.4 8.1 5.3 12.9 9.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1216",
  d: "M926 166.8c4.8-3.8 15.3-10 20.6-12"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1218",
  d: "M922.6 163.5c4.8-6.3 14.4-14.9 17.8-17.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1220",
  d: "M936 133.7a286.9 286.9 0 0 0-18.2 22.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1222",
  d: "M923.6 129.4a157 157 0 0 0-12 21.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1224",
  d: "M885.7 130.4c2.9 7.7 8.2 20.6 10 25.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1226",
  d: "M881.4 138.5c2 3 5.8 9.6 7.2 14.4"
})), /*#__PURE__*/React.createElement("g", {
  id: "pineapple2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1229",
  d: "M897.7 136.1c0-4.3 2.9-9 5.8-9 3.3 0 5.7 5.7 5.7 9 0 3.9-2.9 7.2-5.7 7.2-3 0-5.8-2.8-5.8-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1231",
  d: "M891.5 140c.5-4.8 3.8-8.6 6.7-8.2 2.9.5 4.3 6.3 3.8 9.6-.5 3.8-3.8 6.7-6.2 6.2-2.4 0-4.8-3.3-4.3-7.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1233",
  d: "M904.4 141.4c-1-4.3 1-9 3.9-9.6 2.8-.4 5.7 4.3 6.2 8.2 1 3.8-1.5 7.6-3.9 7.6-2.3.5-5.7-1.9-6.2-6.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1235",
  d: "M897.2 145.2c0-4.7 2.9-9 5.8-9 3.3 0 5.7 5.2 5.7 9 0 3.9-2.8 7.2-5.7 7.2-2.9 0-5.8-2.8-5.8-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1237",
  d: "M888.6 147.6c0-4.3 3.4-9 6.2-9 3 0 5.8 5.7 5.8 9 0 3.9-3.4 7.2-5.8 7.2-2.8 0-6.2-2.8-6.2-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1239",
  d: "M906.3 145.7c0-4.3 3-9 5.8-9 3.3 0 5.7 5.7 5.7 9 0 3.9-2.8 7.2-5.7 7.2-2.9 0-5.8-2.9-5.8-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1241",
  d: "M904.4 149.6c0-4.8 3.4-9.1 6.2-9.1 3 0 5.8 5.2 5.8 9 0 3.9-2.9 7.3-5.8 7.3-2.8 0-6.2-3-6.2-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1243",
  d: "M896.8 153.9c0-4.8 2.8-9.1 5.7-9.1 3.4 0 5.8 5.7 5.8 9 0 4-3 7.3-5.8 7.3-2.9 0-5.8-3-5.8-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1245",
  d: "M884.8 153.9c0-4.8 2.4-9.1 4.8-9.1s4.3 5.7 4.3 9c0 4-2.4 7.3-4.3 7.3-2.4 0-4.8-3-4.8-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1247",
  d: "M911.6 153c0-4.4 2.4-8.7 4.8-8.7s4.8 5.3 4.8 8.6c0 4.3-2.9 7.2-4.8 7.2-2.4 0-4.8-2.9-4.8-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1249",
  d: "M914.5 161c1-4.7 3.8-8.6 5.7-8 2 .4 2.4 6.1 1.5 9.5-.5 4.3-3.4 6.7-5.3 6.2-2-.4-2.9-3.8-2-7.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1251",
  d: "M905.4 159.6c.5-4.3 3.3-8.6 5.7-8.1 2.9 0 4.3 5.7 3.9 9-.5 4.4-3 7.3-5.3 6.8-2.4 0-4.8-3.4-4.3-7.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1253",
  d: "M892 161c-1.5-4.7-4.4-8-6.3-7.6-1.9.5-2.4 6.2-1.4 9.6 1 3.8 3.8 6.2 5.7 5.7 1.5-.4 3-3.8 2-7.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1255",
  d: "M888.6 160.1c0-4.3 2.4-8.6 4.8-8.6 2.9 0 4.8 5.3 4.8 8.6 0 4.3-2.4 7.2-4.8 7.2-2 0-4.8-2.9-4.8-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1257",
  d: "M895.8 162c0-4.8 2.9-9 5.7-9 3.4 0 5.8 5.2 5.8 9 0 3.9-2.9 7.2-5.8 7.2-2.8 0-5.7-2.9-5.7-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1259",
  d: "M898.2 109.3c-1 3.8-4.3 7.2-2 12.5-4.2-1.5-8-2-11.4 1.9 4.3-.5 8.1 1 10 3.8-3.8-.5-5.7 1.5-6.7 3.9 3.4-1 6.7-2 8.2-1.5-1.5 1.5-3.9 3.8-4.3 5.8 2.8-2.4 6.2-2 8.1-3.4-1.4 3.4 1.4 6.7 3.8 10-.4-4.7 2.4-8 1-10.5 4.3 1 4.8 4.8 11 4.8-2.4-1.4-3.8-6.2-6.7-6.2 1.4-.5 7.2-1 8.2 0-1-2-4.4-3.8-6.3-3.8 2-2 5.3-5.8 7.7-6.8-3.4.5-8.6 1-10.5 3.9 4.7-3.9 3.8-11 9-12-2.8-.5-7.1 1.4-10.5 4.8 1.5-2.9 1.5-6.7 3.4-7.7-3.9 1-8.2 5.8-9.6 8.2a18 18 0 0 0-2.4-7.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1261",
  d: "M900.6 117c0 1.4 0 4.3-.5 5.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1263",
  d: "M906.8 116.5c-1 1-2.9 4.3-2.9 7.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1265",
  fill: "none",
  d: "M909.7 122.2a7.6 7.6 0 0 0-3.4 4.4"
})));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "turtle",
  fill: "#059334"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1270",
  d: "M858.9 169.7c-3.4 0-6.2-1.4-8.2-3.8-3.3-4.4-12.4-6.3-16.3-2.4-1.4 1-3.3 1-4.7 1.4-2.4 0-5.3 2.4-4.4 7.2 2-1.5 2.4 0 3.9 0 1-.5.5.5.5 1.4 0 2.4 5.2 7.2 10 6.7 5.3 0 7.7 2 8.6 3 1.5 1.3.5.9 1.5 3.3 1.4 1.4 1.9 1.9-.5 3.8a9.7 9.7 0 0 0 0 14.9c6.2 4.7 22 12 39.8-2 17.2-13.4 44-5.7 46-1 2.4 4.9 3.3 7.7 3.8 10.1.5 2 2.9 3.9 6.3 3.4 3.3 0 7.1 1.4 9 2.9 2.5 1.4 5.8 1 4.9-3.4-2-13.4-10.1-15.3-11-21.5 4.7.4 8 .4 10-1.5 1.4-1.9 3.3-5.3 5.3-6.2 1.4-1 1.4-2-.5-1.5-2.4.5-3.8 1.5-8.2 1-22-2.4-83.8-19.2-95.8-15.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1272",
  fill: "#000",
  d: "M956.7 186a34.8 34.8 0 0 0-9.2 9.6c-4.7 6.2-19.1 12.4-36.9 12.4-17.2 0-27.7-2.8-35.4-9a60.6 60.6 0 0 0-10.6-6.8c-5.2-2.4-6.2-7.7-4.8-12-1.4 2.4-2.3 4.8-5.2 4.3-2 0-5.8 0-4.8 2-.5-1-.5-2.4-1-3l-1-.9c1.5 1 4.9-1.9 7.3-1.9 1.9.5 4.3-1.9 3.8-4.8l-1.4-6.2c3.8-2 54.1 7.2 64.2 8.1 10 .5 38.8 4.8 35 8.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1274",
  d: "M865.6 167.8c4.8-4.8 10.5-7.2 16.3-5.8h1.4c3-2.4 9.6-2.9 13.5-1h1.9c5.7-1.9 16.7 0 20.6 3.9l1.4 1c13-1 20.6 4.7 29.7 13.9 1 1 2.4 2.8 4.8 3.3 2.9.5 3.4 2 1 3.4a37.8 37.8 0 0 0-10 9c-4.4 5.8-18.3 11.6-35.6 11.6-16.7 0-26.8-3-34.5-8.7-4.3-3.3-7.6-5.2-10-6.7-2.9-1-6.7-4.8-5.3-8.6 1-3.8-1.4-8.6-3.3-13.4 1.4-1 5.2-2.4 7.1-1.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g1292",
  fill: "#00493d"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1276",
  d: "M950.4 179.8c-9-9.2-16.7-14.9-29.7-14 0 .5 0 2-.5 3a66.3 66.3 0 0 1 23.5 17.7c2-2 5.3-4.3 6.7-6.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1278",
  d: "M919.3 164.9c-3.9-3.8-14.9-5.8-20.6-3.8 0 1.9 0 4.8-1 6.7 3.4 1.4 6.2 4.8 9.1 8.1 2-.5 6.7-1.9 9.1-2.4a44 44 0 0 0 3.4-8.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1280",
  d: "M896.8 161c-3.9-1.9-10.6-1.4-13.5 1-1 2-1.4 5.8-1.4 7.7 2 0 4.8 1.4 5.7 2.4 3-1 6.8-2.9 8.2-4.3.5-2 1.4-4.8 1-6.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1282",
  d: "M865.6 167.8c4.8-4.8 10.5-7.2 16.3-5.8-1 1.5-1.4 4.3-1.4 7.2-5.3-.5-12 1-14.9 2.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1284",
  d: "M941.8 187.4a64.2 64.2 0 0 0-22-16.8c0 .5-1 2.4-1.5 3.9 2.9 4.3 8.6 13.9 11 19.2 2.4-1 9.1-3.9 12.5-6.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1286",
  d: "M905.4 198a179 179 0 0 0 1.4-19.7c2.4-.5 7.2-1.9 9.1-2.4 2.4 3.9 8.2 14 10.6 18.7-5.8 1.4-15.4 3.8-21.1 3.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1288",
  d: "M888.6 175c2.4-1 5.8-3 8.1-4.8 2 1.4 5.8 4.8 7.2 6.7 0 4.3-1.4 16.8-1.9 21-3.8 0-10-.9-13.4-2.8.5-7.2 1-15.3 0-20.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1290",
  d: "M864.6 180.7c.5-1 1-4.3 1-5.7 3.8-2.4 13.4-4.8 20.6-1 .5 4.8 0 16.8-.5 19.7a96.4 96.4 0 0 0-21-13z"
})), /*#__PURE__*/React.createElement("g", {
  id: "g1308",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1294",
  fill: "#000",
  stroke: "none",
  d: "M840.7 172c-1 0-1.5-2.8-3.4-2.8-.5 0-1.9.5-2.4 0 0 1 .5 2 1 2.4.5 1.4 2.9.5 4.8.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1296",
  d: "M840.7 180.2c5.7 0 6.7-7.2 9.6-7.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1298",
  d: "M844 180.7c4.3 2 7.7-8.1 11-7.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1300",
  d: "M835.4 168.3c1.4 0 2.4-2 4.8.4 1 1 2.4 1.5 3.4 1.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1302",
  d: "M842.6 175.4c-2 3-5.3 4.8-7.2 3.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1304",
  d: "M834.4 163.5c-1.4 1-2.3 2.8-3.3 4.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1306",
  d: "M829.7 170.6v2.4"
})));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "shield",
  fill: "#fff",
  d: "M989.7 233v93.4c0 81-38.3 108.8-89.6 130.8-51.3-22-90-49.8-90-130.8v-93.5h179.6z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "path1313",
  fill: "#c8102e",
  d: "M900.1 312c4.3 0 11-3.8 16.8-9.6 6.2-6.7 16.8-9 27.8 0 11 9.1 17.7 5.3 23.5 0 5.7-5.2 10.5-7.2 21.5-7.2V233H810v62.3c11 0 15.8 2 21.6 7.2 5.7 5.3 12.4 9.1 23.5 0 11.5-9 21.5-6.7 28.2 0 5.3 5.8 12 9.6 16.8 9.6z"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "g1321",
  fill: "#0b50a0"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1315",
  d: "M900.1 360c5.8 0 17.3-6.3 20.1-7.7 10.6-6.3 18.2-.5 24.5 2.4 6.7 2.8 19.1 6.2 26.8 0 7.7-6.3 12-5.8 17.3-5.8 1-7.2 1-14.4 1-22.5v-5.8c-6.8-1.4-10.1.5-17.3 6.8-7.2 6.2-15.4 4.8-26 1-10-4.4-20-12-30.1 0a24.2 24.2 0 0 1-16.3 8c-7.2 0-13.4-4.7-16.3-8-10.5-12-20.1-4.4-30.2 0-10.5 3.8-19.2 5.2-26.3-1-6.7-6.3-10.1-8.2-17.3-6.8v5.8c0 8.1.5 15.3 1.4 22.5 5.3 0 9.2-.5 16.8 5.8 7.7 6.2 20.6 2.8 26.9 0 6.7-2.9 14.3-8.7 24.9-2.4 2.9 1.4 13.9 7.6 20.1 7.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1317",
  d: "M900.1 380.6a51 51 0 0 0 23.5-7.2c9.6-5.3 16.3-3 25.9 1.9 10 4.8 18.2 3.3 24 0 2.8-2 5.2-5.8 11.4-4.3-2.8 12-7.2 22.5-12.4 31.1a32.5 32.5 0 0 1-25-1.9c-10-4.8-22.5-7.7-29.2-3.4a36 36 0 0 1-18.2 5.8c-5.3 0-12-2-18.2-5.8-6.7-4.3-19.2-1.4-29.2 3.4a32.5 32.5 0 0 1-25 2c-5.2-8.7-9.5-19.3-12.4-31.2 6.2-1.5 8.6 2.4 11.5 4.3a23.9 23.9 0 0 0 23.5 0c10-4.8 16.7-7.2 26.3-2a51 51 0 0 0 23.5 7.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1319",
  d: "M900.1 457.2a191.9 191.9 0 0 0 51.3-29.7c-3.9-1.4-6.2-.5-9.6-2.9-3.4-2.4-13.4-3.3-22 1.5a39 39 0 0 1-39.3 0c-8.7-4.8-18.7-3.9-22-1.5-3.4 2.4-5.8 1.5-9.7 3a184.7 184.7 0 0 0 51.3 29.6z"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "lion",
  stroke: "#000",
  strokeWidth: 1.4
}, /*#__PURE__*/React.createElement("path", {
  id: "path1323",
  fill: "#f9d050",
  d: "M887.6 256.4c.5 1-.4 3.4 0 4.3 1 2 1 3 2.4 3.9h3.4c10.5 0 23-4.3 33.5-4.3 10.1 0 16.3 3.3 22 3.3 3.4 0 6.3-2.4 6.3-4.8s-3.8-3.8-12-3.8c-11.5 0-17.7 2.9-27.3 2.9-14.4 0-16.8-5.3-16.8-7.7 0-2.4 2.4-5.7 10.1-5.7 2.4 0 4.3-.5 5.3-1.5.5-1 1.9-2.9 4.8-4.3 3.3-2 10 0 13.4-2.4 0 2-2.9 4.8-5.3 5.8 4.8-1.5 10-1.5 11 2.4-2.4-1.5-6.2-.5-7.6 0-2 .4-2.9 1-4.8 1.4 1.9-.5 2.9 3.3 5.7 3.3-2.8 2.4-7.6 2.4-12.4.5-1.5-.5-5.3-1.9-7.7-1.9-4.8 0-7.7 1-7.7 2.9 0 2.4 3 3.8 11.5 3.8 8.7 0 13.5-2.4 26.4-2.4-1-1.4.5-2.9-1.4-4.3 4.8 0 10 1.4 12 4.8-.5-3.4 2.3-6.2 1.4-9.1 2.9.5 5.3 3.3 5.7 5.7 0-1.4 2-1.4 2-2.8a7.4 7.4 0 0 1 3.8 7.6c1.4-2.4 2.9-1.4 3.8-4.3 1 2 .5 7.7-2.9 9.6 3-2 7.2-2 10.1 1.4-2.9-.4-4.3 1-5.7 1.5A44.4 44.4 0 0 1 948 267c-7.6-.5-8.6-2-13.4-2 2.9.5 8.6 6.3 14 6.3 3.3 0 5.7 0 7.1-.5 1.4-.5 3.8 0 5.7 1 1.5 1.4 4.4 2.8 6.3 2.4-.5 1.9-1.5 2.8-2.9 3.3 2.4 1.5 1 2.4 3.4 4.3-1 0-2 1-3.4.5 1.4 1.4 1.4 3.4 2.9 4.3-.5 0-2 .5-2.9 0 1.4 2 0 4.3 1.4 5.3 1.5 2-1.4 4.3-3.8 2.4.5 1.4-1 2.9-2.4 2.4s-2.4-2-2-2.4c0-.5 0-.5.6-1-1 1.5-2.9 1.5-3.9 1-.4-.5-1-1-1-1.4-3.3 1-4.7-2-4.2-3.4.4-1.4 3.3-2 4.3-1.4 1 .4 1.9 1 2.9 0 1-.5 1.4-1.5 1.4-2.4 0-1.5-1.4-5.8-7.7-5.3-7.2.5-18.7-1.4-24.4-3.4-.5-.4-1-.4-1.5-1 0 2-1.9 3-1.9 4.9 0 2.4 1 4.3 3.9 5.2-1.5 2.4-3.9 2-4.8.5 0 1.5-2 2.4-2 4.3-.4-1-1-1.4-1.4-2.4-1.4 3.4-5.3 5.3-7.2 4.4-2.4 1.9-5.2 1.4-6.2-.5-1.4 1-3.4 1-4.3 0 0 1.4-1 1-1.5 2.9 0 1-1.9 1.4-2.8 1-1-.6-1.5-2.5-.5-3.4-1.4 1-2.9 1-3.8 0 0-1 0-2.4 1-3h.9c-1-.4-2.4 0-3.4-.4-1-1-1-2-.5-2.9.5-.5 2-1.4 3-.5l.4.5c0-1 .5-1.9 1-1.9 1-.5 2.3-.5 3.8 1 1 1.4 1.9 1.4 4.8 1 2.4 0 6.2-2.5 9-4.9-8-1.4-3.3-6.7-.9-8.6-1.9-.5-4.8-.5-6.7.5-10 5.3-20.6 11.5-27.3 9.6a6 6 0 0 0 1 2.8c-1.5 0-4.4 0-5.3-1.4-.5 1-1.4 3.4-.5 5.3-1-1-3.8-2-5.3-2.4 1 1 0 2.9.5 4.3-1.4-1.4-3.8-2.4-4.8-1.4s-2.9 1.4-4.3 1a7.5 7.5 0 0 1-3.8 2.8c0-1 0-2.4-.5-2.9-.5 1.5-2 3.4-3.8 4.3 0-1 0-2.4-.5-3.3 0 1.9-3.8 2.9-4.3 4.3.5-1.4.5-2.9.5-3.8a7.3 7.3 0 0 1-4.8 3.3c.4-1 1-2 .4-2.9-.4 2-3.3 3-5.7 2.4 0 1-2 2.4-4.3 1-1.5-.5-2.4-2-1.5-2.9-1.9 0-3.8-1.9-2.8-3.3 0-.5.4-1 .4-1.5-1.4-1-1.9-2.9-.4-4.3.4-.5 1.9-.5 2.8-.5 0-3.8 3.4-3.8 4.8-1 1 1.5 3.9 3.9 6.3 3.4 1 0 1.4-.5 2.4-.5a43 43 0 0 0 12-6.2c.4-1.4.4-2.4.4-3.3-1.9 1-3.8 1.9-4.8 3.3v-1.4c-1.4 0-3.8-.5-4.8-.5.5-.5 1-2.9 2-3.4-2.4.5-4.8 0-6.8-.4 1-1 1-2.4 1.5-3.9-1 .5-3.4-.4-5.3 0 .5-1.4 1-3.3 2.4-3.8-2 .5-4.3 0-6.7-1 2 0 2.9-2.4 4.3-2.4-3.8 0-4.8-1.9-6.7-2.8 1.4.4 2.4-1 3.8-1-1.4-.5-3.8-2.9-2.8-4.3-.5.5-1 1.4-2 2-1 .4-2.8 0-4.3-1.5-1-2-.5-4.3 1.5-4.8a2.3 2.3 0 0 1-1.5-3.9c.5-1 2.4-2.3 3.4-1l1.4 2c-.5-1-.5-2.9-.5-4.3.5-1.4 1.5-1.4 3-2 1.3 0 2.3 1.5 2.3 3 0 1.4.5 2.3 1 4.3l.4-2c0-1.9 2.4-1.4 3.9-1 1.4.6 1.9 3.4 0 4.9-1 1-.5 2.4.5 3.3 3.3 5.3 9 9.6 13.9 10.1 0-2 1-3.8 2.4-5.3 0-1 .4-2.4 1-3.3.4-2.9 1.8-4.3 3.7-3.4-.4-.5-1-1-1-1.4-1.4-1.5-2.8-3.9-1.8-5.8 1-1.9 3.8-1.4 4.8-.4-.5-3 2.8-5.3 2.8-6.8.5 1.5 1.5 3.4 1 4.8.5-1.9 3.8-4.3 6.2-5.2-1 1.4 2 3.8 1.5 5.2 1-2.4 4.8-3.8 7.6-3.8-1 1-1 2.9-1 3.8 1.5 0 4-.4 4.9-1.9 0 2-1 3.9-2 4.8.5-.5 2.4-.5 3.9-.5-1.5 1.5-1 3-2.4 3.9 1.9-1 4.3-1 4.8 1 1 1.4-.5 3.8-1.5 5.2-1 .5-1.9 1.4-2.4 1.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g1423",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1325",
  d: "M858 262.2c-3.4 1.4-4.4 4.8-4.9 6.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1327",
  d: "M857.5 265.5c-4.8 3-6.8 5.3-5.8 10.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1329",
  d: "M859.8 280c3-1 4.8-2 7.2-6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1331",
  d: "M865.6 275.6c-1 2 0 5.3-1.4 6.7a8.8 8.8 0 0 0 4.8-6.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1333",
  d: "M866.6 280.9c1.9-1 4.8-3.9 6.2-7.2-.5 1.4 0 3.8-1 5.3 2.4-2.4 3.4-3.9 3.9-6.3l.4 2c1-1 2-2 2-3.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1335",
  d: "M878 272.2v2.4c2-1.4 2.5-3.3 2.5-5.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1337",
  d: "M880 271.8c2.9-2 3.3-4.8 3.3-9.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1339",
  d: "M883.3 267.5c2-1.5 2.4-2.4 2.4-6.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1341",
  d: "M879.5 247.8c-1 0-2 .5-2 2 0 .9-1.4 2.3-1.4 3.8-.4 1.9-1.4 2.4-2.8 1.9-1.5-1-1.5-1-1.5-2.4 0-2 2.4-2.4 2.4-4.3.5-1 1-2.4 1.5-2.4-2.4 1.4-5.8.4-6.3-2.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1343",
  d: "M883.8 249.2c-1 .5-2-1-3.3-.4-.5 0-2 .4-2.4 0"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1345",
  d: "M877.1 251.6c.5.5 2.9 1.5 5.3.5-2 .5-3.4-1.9-1.5-3.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1347",
  d: "M872.8 246.8c-2 0-3.4 1.5-2.9 3 .5 1.4 2.4 1.4 3.8.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1349",
  d: "M869.4 270.8c.5-.5 1-1.4 1-2 1 0 2-.4 2.4-.9 1.9 0 3.3-1.4 3.8-2.8 1 0 1.5-2.4 2-3.4.4.5 1.4 0 1.9-2 1 .6 2.4 0 2.8-1.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1351",
  d: "M863.7 255c0 .5-1 1.4-2 2 .5.9 0 3.3-.9 3.7.5 1 0 2.4-.5 3.4 0 .5.5 2 .5 2.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1353",
  d: "M865.6 245.4c-1 2.4-.5 5.3 1.4 5.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1355",
  d: "M866.6 253c-.5 2.5-.5 5.8-1 7.3-.5 1-1.4 4.3 2.4 5.2 4.3 1 6.7.5 9.1-6.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1357",
  d: "M884.3 277.5c0 .5-.5 1.5-1.4 1.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1359",
  d: "M887.6 276.6c0 1-1 2.4-1.4 2.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1361",
  d: "M891 275.6c0 1 0 2.4-1 2.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1363",
  d: "M861.8 245.9c.4 0 1 1 1.4 1.9-1.4-1-2.9 1.4-2 2.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1365",
  d: "m860.3 254-1.9 1.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1367",
  d: "M858.9 258.3c-.5 0-1 .5-1.4.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1369",
  d: "M835.9 249.7c0-.5 0-.5.5-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1371",
  d: "M831.6 248.3c-.5 0-.5 0-1-.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1373",
  d: "M832 255h1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1375",
  d: "M830.1 252.1a5 5 0 0 0-2.8-1.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1377",
  d: "M856.5 269.9c-3.4 2.8-4.8 5.2-5.3 8.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1379",
  d: "M859.8 272.2a11 11 0 0 1-3.8 4.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1381",
  d: "M841.2 286.6a11 11 0 0 1-9.6-1.4c-.5-.5-1-.5-1.5-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1383",
  d: "M855.5 280c-.4 1.8-1 4.2-1.9 4.7 3.9-2 7.2-4.8 7.7-9.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1385",
  d: "M827.7 289c1.5-.5 3 .5 3.9-.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1387",
  d: "M911.1 273.2c1 .5 2.4 1 2.9 1.4.5-1 2.4-2.4 3.8-2.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1389",
  d: "M877.1 283.3c-.5-2 .5-4.3 3.4-5.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1391",
  d: "M858.4 291.4c.5-1 .5-2.4 1-3.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1393",
  d: "M837.3 292.9c-.5 1-1.4 1.9-1.4 2.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1395",
  d: "M830.1 293.8s0-.5.5-.5c1-.4 2.4-1.4 2.9-2.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1397",
  d: "M895.3 287.1c-1 .5-1.4 0-1.9-.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1399",
  d: "M894.8 289.5s-.4.5-1 .5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1401",
  d: "M897.2 291.9c-.5.5-1 1-1.4 1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1403",
  d: "M911.1 292.9c1-.5 1.5-1.5 2-3.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1405",
  d: "M904.9 292.4c1.4-.5 2.4-1.5 3.8-2.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1407",
  d: "M918.3 288.5c0-1 0-1.9.5-2.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1409",
  d: "M953.8 292.9c-1-1-1-2.4.5-3.4 1-.5 1.4-1 2.4-1.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1411",
  d: "M924.5 276c-7.6-3.3-7.1-7.6-13.4-7.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1413",
  d: "M958.6 291c.5.4 0 1.9 0 2.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1415",
  d: "M962.9 291c-.5 1.4-.5 1.9-.5 3.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1417",
  d: "M926 245.9h-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1419",
  d: "M885.7 262.2c0 1 1.5 2.9 5.3 2.9-.5 0-1-.5-1-.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1421",
  d: "M887.6 256.4c-.4.5-1 0-1 0-.9-1 .6-2.8 2-3.8-1.4.5-2.4.5-3.4.5-1 2.9-3.8 4.3-5.7 2.4-.5 1.9-2.9 4.3-4.8 3.8-2-1-2.4-2.4-2-3.8-2.3 2.8-5.2 1-6.1 0-.5-1 0-3.4 1-6.3"
})), /*#__PURE__*/React.createElement("path", {
  id: "path1425",
  fill: "#000",
  stroke: "none",
  d: "M918.3 274.6c-1.4 1-2.9 0-4.3 1.5-1 1 .5 1.4 1.4 1.4-.4 1.5-.4 2 2 2-1 1.4 1.9 1.9 1.4 3.8a4.6 4.6 0 0 0 1-4.8c-.5-1.5-3-2.4-1.5-3.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g1461",
  fill: "#073163",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1427",
  d: "M874.7 259.3c-2-1-2.4-2.4-2-3.8-.4 1-1.3 1.4-2.3 1.4-2 4.3-4.3 8.2-7.2 8.2-3.4.4-2.9 3.8-.5 3.8 5.3 1 7.7-1 12-9.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1429",
  d: "M827.3 247.8c1.4-1.4.4-2.9-.5-3.3-1.5-.5-4.3 0-5.8 2.3 1.5-.4 3-.4 3.4.5.5 1 1.4 2 2.9.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1431",
  d: "M829.7 239.2c3.3 0 4.3.5 4.7 1.9.5 1-.4 2.4-1.4 2.4-1.4 0-2.9-1-2.4-1.4.5-1 .5-2.4-1-3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1433",
  d: "M839.2 246.8c2.4.5 3.4-1 2-2.8-.5-1.5-2-2.4-4.4-2 2.4 1.5 0 3.9 2.4 4.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1435",
  d: "M821.5 255a4 4 0 0 0 4.8 2c1.4-.6 2-2 1.4-3-1-1.4-2.4-1.9-2.8 0-1 2-2.4 1.5-3.4 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1437",
  d: "M828.7 284.2c-1-1.9-3.8-1.9-6.2 0 1-.5 2.8 0 3.3 1s1.5 1 2 1c.4-.5 1.4-1 .9-2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1439",
  d: "M832.5 281.4c0-2.4-3.3-3-5.2-2 1 0 2.4 1 2.4 2 .4 1 1.4 1.4 1.9 1.4 1-.5 1.4-1 1-1.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1441",
  d: "M827.7 290c-2.8-.5-4.3 2.9-4.3 5.2.5-1.4 2-2.3 3.4-1.9 1.4 0 1.9-.4 1.9-1.4.5-1 0-1.4-1-2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1443",
  d: "M828.2 298.1c1 .5 2-.5 2.4-1.9 0-1 2-1 2.4-.5 1 .5 1 2.4-.5 3.4-1 .5-3.3 1-4.3-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1445",
  d: "M894.8 283.7c-1-.4-3.3-1.4-5.2 0 1.4-.4 2.4.5 2.8 1.5 0 1 1.5 1.4 2 .5.4-.5 1-1.5.4-2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1447",
  d: "M890.5 287.1c-1.9-1-4.3 1.4-4.8 3.4a7 7 0 0 1 3.4-1.5c1 .5 1.9 0 1.9-1 .5-.4.5-.9-.5-.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1449",
  d: "M893 291c-1.5 0-3.4 1.9-3.4 3.8.4-1 1.4-1.5 2.4-1 1 0 2.4-.5 2.4-1.4 0-1-.5-1.5-1.5-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1451",
  d: "M897.2 294.8c-1-.5-2.4 0-2.4 1.4s0 2.9-.4 3.4c1-1 1.9-1.5 2.8-2 .5-.4 1-1.9 0-2.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1453",
  d: "M951.4 290.5c-1-1-2.4-.5-2.9.4-.5 1-1 3.4 0 5.3 0-1 1-2.4 2-2.4 1.4-.5 1.8-2.4.9-3.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1455",
  d: "M954.3 292.4c-2 1-2 4.3-.5 6.2 0-1 .5-2.4 1.4-2.9 1.5 0 2-1.9 1.5-2.8-1-1-2-.5-2.4-.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1457",
  d: "M960 294.3c-1-.5-2 .5-2 1.4-.4 1.5.6 3.4 2 4.3 0-1 .5-1.9 1-2.4 1.4-1 1-2.8-1-3.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1459",
  d: "M964.3 293.8c-1 0-1.9 1.4-1 2.9.5 1 1.5 1.4 3.4 1-.5 0-1.4-1.5-1-2 .5-1 0-1.9-1.4-1.9z"
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "star"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1464",
  fill: "#f9d050",
  d: "m831.1 383.4 24-73.8 24 73.8-62.9-45.5H894Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1466",
  fill: "#024919",
  d: "m835.9 376.7 49.8-36.4h-61.3l49.3 36.4-18.6-58.4z"
}));

var _ref20 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  id: "use1469",
  width: "100%",
  height: "100%",
  x: 90.1,
  y: 0
});

var _ref21 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  id: "use1471",
  width: "100%",
  height: "100%",
  x: 45,
  y: 52.2
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "path1473",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.4,
  d: "M989.7 233v93.4c0 81-38.3 108.8-89.6 130.8-51.3-22-90-49.8-90-130.8v-93.5h179.6z"
});

var SvgKy = function SvgKy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-icons-ky",
    viewBox: "0 0 640 480",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("g", {
    id: "motto",
    style: {
      stroke: "#000",
      strokeWidth: 1.4
    },
    transform: "translate(-306.8 -21.2) scale(.87136)"
  }, _ref9, _ref10, _ref11), /*#__PURE__*/React.createElement("g", {
    id: "crest",
    style: {
      stroke: "#000",
      strokeWidth: 1.4
    },
    transform: "translate(-306.8 -21.2) scale(.87136)"
  }, _ref12, _ref13, _ref14), /*#__PURE__*/React.createElement("g", {
    id: "g1475",
    stroke: "none",
    style: {
      strokeWidth: 1.4
    },
    transform: "translate(-306.8 -21.2) scale(.87136)"
  }, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ky.c45a6056.svg";
export { ForwardRef as ReactComponent };